import { createContext } from '@berlin-front/common/composables/context';

export type AtoneAuthCompleteType = {
  useComplete: () => void;
};

export const AtoneAuthCompleteContext = createContext<AtoneAuthCompleteType>({
  useComplete: () => {},
});
